var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrow2Directions = function SvgArrow2Directions(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "m15.812 14.23 3.492-3.491a1.166 1.166 0 0 0 0-1.648l-3.492-3.493a1.166 1.166 0 0 0-1.648 1.648l1.506 1.506H4.993L6.5 7.246a1.166 1.166 0 0 0-1.648-1.648L1.36 9.091a1.166 1.166 0 0 0 0 1.648l3.492 3.492A1.166 1.166 0 0 0 6.5 12.583l-1.502-1.502h10.677l-1.506 1.506a1.166 1.166 0 0 0 1.648 1.648z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 20h20V0H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrow2Directions);
export default ForwardRef;